import { TRANSMISSION_TYPE_STATUS_LABEL } from 'src/services/manage_suppliers/supplierMapper';

/** Display/filter values for the Order Type grid column (see toTransmissionTypeLabel). */
export const TRANSMISSION_TYPE_STATUS_FILTER_OPTIONS = [
  TRANSMISSION_TYPE_STATUS_LABEL.onlineCatalog,
  TRANSMISSION_TYPE_STATUS_LABEL.onlinePunchout,
  TRANSMISSION_TYPE_STATUS_LABEL.offlineEmail,
  TRANSMISSION_TYPE_STATUS_LABEL.pendingValidation,
  TRANSMISSION_TYPE_STATUS_LABEL.validationFailure,
  TRANSMISSION_TYPE_STATUS_LABEL.offlineLogOnly,
  TRANSMISSION_TYPE_STATUS_LABEL.inactive,
  TRANSMISSION_TYPE_STATUS_LABEL.archived,
] as const;

export type TransmissionTypeStatusFilterOption =
  (typeof TRANSMISSION_TYPE_STATUS_FILTER_OPTIONS)[number];
